type RecordItems = {
    defecation: string;
    defecationAndUrine: string;
    urine: string;
    none: string;
};

export const recordColors: RecordItems = {
    defecation: '#AE8315',
    defecationAndUrine: '#FF7152',
    urine: '#72FBFD',
    none: '#C4C4C4',
};
export const getRecordNames = (t: (key: string, fallback: string) => string): RecordItems => ({
    defecation: `${t('stool', '排便')}：${t('yes', '有')}`,
    defecationAndUrine: `${t('stool', '排便')}・${t('urine', '排尿')}：${t('yes', '有')}`,
    urine: `${t('urine', '排尿')}：${t('yes', '有')}`,
    none: `${t('stool', '排便')}・${t('urine', '排尿')}：${t('no', '無')}`,
});

export const heatmapColorStops: { [key: string]: [number, string][]} = {
  sensor: [
    [0, '#FEECCA'],
    [0.1, '#FDD4A8'],
    [0.2, '#FDCB82'],
    [0.3, '#FCBF5D'],
    [0.4, '#FBB538'],
    [0.5, '#FAA612'],
    [0.6, '#F59800'],
    [0.7, '#E38800'],
    [0.8, '#D47800'],
    [0.9, '#C66800'],
    [1, '#CC6A00']
  ],
  commonTrend: [
    [0, '#FFE8E3'],
    [0.1, '#FFD1CA'],
    [0.2, '#FFB9B0'],
    [0.3, '#FFA296'],
    [0.4, '#FF8A7C'],
    [0.5, '#FF7362'],
    [0.6, '#F55F51'],
    [0.7, '#E64C44'],
    [0.8, '#D83A38'],
    [0.9, '#C8282C'],
    [1, '#B21620']
  ],
  temperature: [
    [0, '#C0E5F9'],
    [0.06667, '#C1DEF4'],
    [0.13334, '#C4D1EA'],
    [0.2, '#C7C3DF'],
    [0.26668, '#CAB6D5'],
    [0.33335, '#CDA8CB'],
    [0.4, '#D09BC0'],
    [0.46669, '#D38DB6'],
    [0.53336, '#D680AC'],
    [0.6, '#D972A1'],
    [0.6667, '#DB6597'],
    [0.73337, '#DE578D'],
    [0.8, '#E14A83'],
    [0.86671, '#E43C78'],
    [0.93338, '#E72F6E'],
    [1, '#EA2166']
  ],
  humidity: [
      [0, '#E9F6FD'],
      [0.16667, '#BAD4EA'],
      [0.33334, '#8CD1D7'],
      [0.50001, '#75A0CE'],
      [0.66668, '#5D8FC5'],
      [0.83335, '#467EBB'],
      [1, '#2F6CB2']
  ],
}
